export const APP_NAME = "NEXUS TRADE"

export const APP_VERSION = "1.0.2"

export const BUILD_DATE = "2025-12-23"